<div class="d-flex">
	<div class="col-12 padd0">
		<div *ngIf="editMode && isUploading" class="loading-container" style="border: 1px solid #D0D5DD;">
			<div class="spinner-box">
				<div class="circle-border"></div>
			</div>
			<div class="progress-text">Uploading... {{progress.percentage}}%</div>
		</div>

		<div class="d-flex gap-12 uploadImagezone" *ngIf="editMode && imagelink && !isUploading">
			<div class="outputImg">
				<div class="affichage">
					<img [src]="imagelink" alt="Bot avatar" />
				</div>
			</div>
			<div class="ChangeImg">
				<label class="fu-dropzone fu-dropzone--change">
					<input type="file" class="fu-file-input" (change)="selectFile($event)"
						accept="image/png,image/jpeg,.png,.jpg,.jpeg" />
					<span class="iconUpload"><img src="../../../assets/images/upload.svg" alt="" /></span>
					<span class="btn-change primary-color fw-bold">Change your image</span>
				</label>
				<span>Or</span>
				<button type="button" class="btn-successs" style="margin-bottom: 7px;" (click)="URLInput($event)">
					Change image from URL
				</button>
			</div>
		</div>

		<div class="blocimage" *ngIf="editMode && !isUploading && !imagelink">
			<label class="fu-dropzone">
				<input type="file" class="fu-file-input" (change)="selectFile($event)"
					accept="image/png,image/jpeg,.png,.jpg,.jpeg" />
				<span class="iconUpload mt-0 mb-1">
					<img src="../../../assets/images/upload.svg" alt="" />
				</span>
				<span class="btn-change" style="margin: 0; color: var(--Principal-05,#418987); font-weight: 600;">
					Click to upload image
				</span>
			</label>
			<span class="separator-text">Or</span>
			<button type="button" class="btn-url" (click)="URLInput($event)">
				Add image from URL
			</button>
		</div>
	</div>
</div>
